/**
 * v2.0.1 standalone MeterValues.
 *
 * Used only when there is no active transaction on the connector (e.g.
 * clock-aligned samples for an idle EVSE). During an active transaction
 * the adapter routes MeterValues into `TransactionEvent(Updated)`
 * with embedded `meterValue: [...]` instead — see
 * `OcppV201Adapter.meterValues()` for the dispatch.
 *
 * Wire shape: `{ evseId, meterValue: MeterValueType[] }`. Domain
 * `MeterValuesDomain.connectorId` is the global ConnectorId; we
 * default `evseId = 1` (single-EVSE topology — see
 * `statusNotification.ts` for the same shortcut).
 */
import type { MeterValuesDomain } from '@/protocol/OcppAdapter';

const DEFAULT_EVSE_ID = 1;

export function buildMeterValuesRequest(req: MeterValuesDomain): Record<string, unknown> {
  return {
    evseId: DEFAULT_EVSE_ID,
    meterValue: req.meterValue.map((mv) => ({
      timestamp: mv.timestamp,
      sampledValue: mv.sampledValue.map((sv) => ({
        value: Number(sv.value),
        ...(sv.measurand !== undefined ? { measurand: sv.measurand } : {}),
        ...(sv.context !== undefined ? { context: sv.context } : {}),
        ...(sv.unit !== undefined
          ? { unitOfMeasure: { unit: sv.unit } }
          : {}),
        ...(sv.location !== undefined ? { location: sv.location } : {}),
        ...(sv.phase !== undefined ? { phase: sv.phase } : {}),
      })),
    })),
  };
}
